import axios from "axios";
import authHeader from "../auth-header";

const API_URL = process.env.REACT_APP_API_URL + "api/";

class DScribeJobsService {
  async getVScribeAiDictStatus() {
    return axios.get(API_URL + "DScribeJobs/vscribeai/dict-status", {
      headers: await authHeader(),
    });
  }

  async getVscribeAiDeviceInfo() {
    return axios.get(API_URL + "users/get-devices-info", { headers: await authHeader() });
  }

  async getVScribeAiNotificationLogs() {
    return axios.get(API_URL + "users/app-notification-logs", { headers: await authHeader() });
  }
}

const dScribeJobsService = new DScribeJobsService();
export default dScribeJobsService;
